import cn from "classnames";
import { useState } from "react";
import { DialogProps } from "./types";
import styles from "./styles.module.scss";

export const useOverlayAnimation = ({
  onExit,
  onEnter,
  onExited,
  onEntered,
}: Pick<DialogProps, "onEnter" | "onEntered" | "onExit" | "onExited">) => {
  const [entering, setEntering] = useState(false);
  const [exiting, setExiting] = useState(false);

  const handleEnter = () => {
    setEntering(true);
    onEnter?.();
  };

  const handleEntered = () => {
    setEntering(false);
    onEntered?.();
  };

  const handleExit = () => {
    setExiting(true);
    onExit?.();
  };

  const handleExited = () => {
    setExiting(false);
    onExited?.();
  };

  return {
    animationClassNames: cn({
      [styles.entering]: entering,
      [styles.exiting]: exiting,
    }),
    handleExit,
    handleEnter,
    handleExited,
    handleEntered,
  };
};
